// Framer Motion presets — single source of truth (animations-and-effects.md)

export const springs = {
  card: { type: "spring", stiffness: 350, damping: 22 },   // modals, drawers, cards
  icon: { type: "spring", stiffness: 600, damping: 35 },   // toggles, hamburger, icon states
  widget: { type: "spring", stiffness: 280, damping: 24 }, // expanding widgets, dropdowns
  press: { type: "spring", stiffness: 600, damping: 30 },  // button press release
};

export const revealVariant = {
  hidden: { opacity: 0, y: 24, filter: "blur(12px)" },
  visible: { opacity: 1, y: 0, filter: "blur(0px)" },
};

export const revealTransition = { duration: 0.5, ease: [0.22, 1, 0.36, 1] };

export const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.06 } },
};

// Page transitions are linear fades — never spring.
export const pageFade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.15, ease: "linear" },
};

export const tapPress = { scale: 0.96, y: 1 };
